import type { AsrHealthResponse } from '../api/types';

export const isAsrHealthResponse = (value: unknown): value is AsrHealthResponse => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const candidate = value as { adapters?: unknown };
  return Array.isArray(candidate.adapters) && candidate.adapters.every((adapter) => typeof adapter === 'string');
};
